import { render, staticRenderFns } from "./AssessmentApplicationData.vue?vue&type=template&id=31ccdff0&scoped=true"
import script from "./AssessmentApplicationData.vue?vue&type=script&lang=js"
export * from "./AssessmentApplicationData.vue?vue&type=script&lang=js"
import style0 from "./AssessmentApplicationData.vue?vue&type=style&index=0&id=31ccdff0&prod&scoped=true&lang=css"
import style1 from "./AssessmentApplicationData.vue?vue&type=style&index=1&id=31ccdff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccdff0",
  null
  
)

export default component.exports